module.exports = __webpack_public_path__ + "static/media/p4_image1.84f4fcdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/p4_image1.jpg
// module id = 2521
// module chunks = 0